import { Typography } from '@breetometer/components';
import { OTPLENGTH } from 'BreetHelpers';
import { kybAuthSelectors, useAppSelector } from 'BreetRedux';

const KybOTPHeader = () => {
	const { selectKybCredentials } = kybAuthSelectors;

	const credentials = useAppSelector(selectKybCredentials);
	return (
		<div className='registerYourBusinessAuth_otp_header'>
			<Typography
				as='h1'
				variant='big_header'
				className='color-neutral-50'
			>
				Verify your email
			</Typography>
			<Typography
				as='p'
				variant='sub_head'
				className='color-primary-50'
			>
				Enter the {OTPLENGTH}-digit OTP sent to
				<br />
				<span>{credentials.email}</span>
			</Typography>
		</div>
	);
};

export default KybOTPHeader;
